
import { defineComponent } from 'vue';

export default defineComponent({
	/**
	 * business logic only
	 */
});
